import * as yup from 'yup'
import i18n from 'config/i18n'
import { TaskState } from 'state/tasks'
import { parseBackendDate } from 'services/dates'
import { Country } from 'services/api/constants'

export const POST_TIME_WINDOW_SCHEMA = (task: TaskState | null | undefined, country: Country) =>
    yup
        .object({
            start: yup.string().nullable(),
            end: yup.string().nullable(),
        })
        .nullable()
        .test({
            message: () => ({
                start: i18n.t<string>('errorMessage.validation.selectDate', 'Please select both start and end dates'),
                end: i18n.t<string>('errorMessage.validation.selectDate', 'Please select both start and end dates'),
            }),
            test: (value: { start?: string | null; end: string | null }) => {
                // Note: the `start` and `end` could be both blank or both filled
                if (!value || (!value.start && !value.end)) return true
                return Boolean(value && value.start && value.end)
            },
        })
        .test({
            message: () => ({
                start: i18n.t(
                    'errorMessage.businessLogic.enterEndDateAfterStartDate',
                    'End date should be after the start date. Please enter another date.',
                ),
                end: i18n.t(
                    'errorMessage.businessLogic.enterEndDateAfterStartDate',
                    'End date should be after the start date. Please enter another date.',
                ),
            }),
            test: (value: { start?: string | null; end: string | null }) => {
                // Note: the `start` and `end` could be both blank
                if (!value || (!value.start && !value.end)) return true
                const startDate = new Date(value && value.start ? value.start : '')
                const endDate = new Date(value && value.end ? value.end : '')
                return endDate > startDate
            },
        })
        .test({
            message: () => {
                if (!task) return { start: '', end: '' }
                return {
                    start: i18n.t<string>('errorMessage.validation.selectPublishDateWithinStepSchedule', {
                        defaultValue: 'Dates have to be within the step schedule: {{start}} - {{end}}',
                        start: parseBackendDate(task.steps[1].time_window.start, country, {
                            showTime: false,
                            showYear: false,
                        }),
                        end: parseBackendDate(task.steps[1].time_window.end, country, {
                            showTime: false,
                            showYear: false,
                        }),
                    }),
                    end: i18n.t<string>('errorMessage.validation.selectPublishDateWithinStepSchedule', {
                        defaultValue: 'Dates have to be within the step schedule: {{start}} - {{end}}',
                        start: parseBackendDate(task.steps[1].time_window.start, country, {
                            showTime: false,
                            showYear: false,
                        }),
                        end: parseBackendDate(task.steps[1].time_window.end, country, {
                            showTime: false,
                            showYear: false,
                        }),
                    }),
                }
            },
            test: (value: { start?: string | null; end: string | null }): boolean => {
                // Note: the `start` and `end` could be both blank
                if (!task || !value || (!value.start && !value.end)) return true
                const startDate = new Date(value && value.start ? value.start : '')
                const endDate = new Date(value && value.end ? value.end : '')
                const stepStart = new Date(
                    parseBackendDate(task.steps[1].time_window.start, country, { showTime: true }),
                )
                const stepEnd = new Date(parseBackendDate(task.steps[1].time_window.end, country, { showTime: true }))
                return startDate >= stepStart && startDate < stepEnd && endDate > stepStart && endDate <= stepEnd
            },
        })
